<template>
  <div class="shade">
    <slot></slot>
  </div>
</template>

<script>
  import { Graphics } from 'pixi.js-legacy'
  import { getColor, getShadeVariant } from '../utilities/colors'

  export default {
    name: "shade",
    props: {
      range: {
        type: Array,
      },
      color: {
        type: String
      },
      index: {
        type: Number
      },
      variant: {
        type: String
      },
    },
    data() {
      return {
        instance: new Graphics(),
      }
    },
    computed: {
      fromUnit() { return Number(this.range[0]) },
      toUnit() {   return Number(this.range[1]) },
      colorInt() {
        console.log("shade - colorInt")
        let variant = this.variant
        if ( !variant )
          variant = getShadeVariant(this.index)

        if ( !this.color )
          console.log(this.$parent.color)

          return getColor(this.$parent.color, variant)

        return getColor(this.color, variant)
      },
    },
    inject: [
      'convertToPixels',
      'convertToUnits',
      'panelHeight',
      'panelWidth',
      'addToPanel',
    ],
    methods: {
      render() {
        let sense = this.$parent.sense === 'top' ? 0 : 1
        let x = this.convertToPixels(this.fromUnit)
        let width = this.convertToPixels(this.toUnit) - x
        let height = this.panelHeight/3
        let y = 10 + height*sense

        this.instance.name = 'Shade'
        this.instance.beginFill(this.colorInt)
        this.instance.drawRect(0, y, Math.abs(width), height)
        this.instance.endFill()

        this.instance.x = x

        this.instance.width = width
        this.instance.zIndex = 2
      },
      reRender() {
        this.instance.x = this.convertToPixels(this.fromUnit)
        this.instance.width = this.convertToPixels(this.toUnit) - this.instance.x
      }
    },
    watch: {
      range() {
        this.reRender()
      },
      index() {
        this.reRender()
  // Recalculate your PixiJS geometry or shading positions here
      }
    },
    created() {
      this.render()
      this.addToPanel(this.instance)
    },
    beforeUnmount() {
      console.log("beforeDestroy - Shade")
      if (this.instance.parent) {
        this.instance.parent.removeChild(this.instance)
      }
      this.instance.destroy({children: true})

      //this.instance.clear()
      //this.instance.destroy({children: true})
    },
  }
</script>

<style scoped>

</style>
